import {SAVE_ANON_EVENT_PAGE, SAVE_EVENT_PAGE} from "../../e-learning-dashboard/constants";
import { post } from "../../e-learning-display/helper/main";

export const saveCustomEvent = (eventName) => {
    post(SAVE_EVENT_PAGE, {
      name: eventName,
    });
  };


export const postInitEvent = (type, data, result, playerId) => {
  post(SAVE_ANON_EVENT_PAGE, {
    playerId:playerId,
    name: type,
    microtime: Date.now() / 1000,
    result: result,
    data: data,
  });
};
  